export default __webpack_public_path__ + "static/media/Patch 1.1c5ae39b.png";